/**
 * Функция отрисовки модальных окон \ попапов.
 * @param {Object} options
 * @param {string} options.blockName - Имя блока, если параметр не передан то по умалчанию будет 'modal-dialog'.
 * @param {string} options.dialogClass - Классы обертки родителского элемента контента и кнопки закрытия.
 * @param {Function} options.open - Функция принимающая коллбэки при открытии окна.
 * @param {Function} options.close - Функция принимающая коллбэки при закрытии окна.
 * @param {Function} options.update - Функция принимающая Object с новыми опциями, передать нужно весь список опций, а не только обновляемых.
 * @param {HTML Element} options.content - HTML элемент содержащий основной контент и скриптов окна.
 * @return {Object}
 */
import dialogTemplate from './dialog.handlebars';

function modalDialog(initialOptions) {
  var dialog = {
    options: Object.assign({
      blockName: 'modal-dialog'
    }, initialOptions),
    open: function open() {
      document.body.append(this.dialogEl);
    },
    destroy: function destroy() {
      this.dialogEl.remove();
    },
    close: function close() {
      this.destroy();
      this.options.close && this.options.close();
    },
    lockFocusInDialog: function lockFocusInDialog() {
      var focusableEls = this.dialogEl.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
      var firstFocusableEl = focusableEls[0];
      var lastFocusableEl = focusableEls[focusableEls.length - 1];
      var KEYCODE_TAB = 9;
      firstFocusableEl.focus();
      this.dialogEl.addEventListener('keydown', function (evt) {
        var isTabPressed = evt.key === 'Tab' || evt.keyCode === KEYCODE_TAB;

        if (!isTabPressed) {
          return;
        }

        if (evt.shiftKey) {
          if (document.activeElement === firstFocusableEl) {
            lastFocusableEl.focus();
            evt.preventDefault();
          }
        } else {
          if (document.activeElement === lastFocusableEl) {
            firstFocusableEl.focus();
            evt.preventDefault();
          }
        }
      });
    },
    executeScripts: function executeScripts() {
      var _this = this;

      this.dialogEl.querySelectorAll('script').forEach(function (executedScriptEl) {
        var scriptEl = document.createElement('script');
        scriptEl.innerHTML = executedScriptEl.innerHTML;

        _this.dialogEl.append(scriptEl);
      });
    },
    init: function init() {
      this.dialogEl = document.createElement('div');
      this.dialogEl.innerHTML = dialogTemplate({
        blockName: this.options.blockName,
        popupClass: this.options.dialogClass
      });
      this.dialogEl = this.dialogEl.firstElementChild;
      this.dialogEl.querySelector(".js-".concat(this.options.blockName, "__content")).append(this.options.content);
      this.dialogEl.querySelector(".js-".concat(this.options.blockName, "__close")).addEventListener('click', this.close.bind(this));
      this.dialogEl.querySelector(".js-".concat(this.options.blockName, "__overlay")).addEventListener('click', this.close.bind(this));
      this.open();
      this.executeScripts();
      this.options.open && this.options.open();
      this.lockFocusInDialog();
    },
    update: function update(newOptions) {
      this.options = Object.assign({
        blockName: 'modal-dialog'
      }, initialOptions);
      this.destroy();
      this.init();
    }
  };
  dialog.init();
  return dialog;
}

export { modalDialog };